import React, { useMemo } from 'react';

import BundleEditView from '@components/shared/bundles/BundleEditView';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';

import operatorBundleService from '@services/operator/bundleService';

interface InventoryTypeOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface MerchantInventoryType {
  merchant_id: string;
  enabled?: boolean;
  inventory_type: InventoryTypeOption;
}

const OperatorBundleEdit: React.FC = () => {
  const { merchantInventoryTypes, currentMerchant } = useOperatorData();
  const { handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  // currentMerchant 在 edit 模式下會被 useRecordMerchantSync 切到 record 所屬 merchant，
  // 直到 sync 完成前 merchantDataLoading 為 true 擋住 form 渲染，避免閃錯的下拉。
  const effectiveMerchantId = currentMerchant?.id ?? null;

  const inventoryTypes = useMemo<InventoryTypeOption[]>(() => {
    if (!effectiveMerchantId) return [];
    return (merchantInventoryTypes as MerchantInventoryType[] | undefined ?? [])
      .filter(mit => mit.merchant_id === effectiveMerchantId && mit.enabled !== false)
      .map(mit => mit.inventory_type);
  }, [merchantInventoryTypes, effectiveMerchantId]);
  const productService = useOperatorProductService();

  // 編輯模式：wrapper 由 onBundleLoaded 拿到 record's merchant_id 後同步 context，
  // 整個過程 merchantDataLoading 為 true 擋住 form 渲染，避免閃錯的下拉與 ProductSelect 過濾。
  return (
    <BundleEditView
      bundleService={operatorBundleService as any}
      productService={productService as any}
      inventoryTypes={inventoryTypes}
      role="operator"
      merchantId={effectiveMerchantId}
      onBundleLoaded={handleRecordLoaded}
      merchantDataLoading={merchantDataLoading}
    />
  );
};

export default OperatorBundleEdit;
